/**
 * The heat sources, in words a human reads.
 *
 * One list, imported by everything that shows heat to somebody — the debug
 * overlay's rolling five and the post-fight screen's round summary. It started
 * as a private helper in the overlay, and the moment a second screen wanted the
 * same words the only two options were to import it or to write it out again.
 * A second copy of a lookup table is a second copy that drifts, and this
 * project has already paid for that twice (gotcha 29).
 */

const WORDS = Object.freeze({
  environmentalFinish: 'finished on the arena',
  weapon: 'weapon',
  counter: 'counter',
  taunt: 'taunt',
  blazin: 'blazin blow',
  dangerWin: 'won from the floor',
  home: 'their own room',
  plainWin: 'plain win',
  ducked: 'ducked the reach',
  flee: 'backing away',
  repetition: 'repetition',
  stale: 'the same look again',
});

/**
 * One heat event, as a line somebody can read without the tuning table open.
 *
 * `who` replaces the event's own `opponent`, which is a **slot id** — `player`
 * or `opponent` — rather than anybody's name. A caller that knows who was in
 * the other corner passes it; the debug overlay, which is about slots, does not.
 */
export function heatWords(event, { who: named = null } = {}) {
  if (!event) return '';
  const who = event.opponent ? ` · ${named ?? event.opponent}` : '';
  const what =
    event.type === 'repetition' && event.move ? `all ${event.move}` : WORDS[event.type];
  return `${what ?? event.type}${who}`;
}

export { WORDS as HEAT_WORDS };
